import * as React from 'react';

function SvgActFilter(props) {
    return (
        <svg
            viewBox="0 0 128 128"
            {...props}
        >
            <path
                d="M106.79 13H21.21a11.22 11.22 0 00-8.3 18.76L50 72.54V111a4 4 0 002.26 3.6 3.89 3.89 0 001.74.4 4 4 0 002.5-.88l7.5-6 12.5-10A4 4 0 0078 95V72.54l37.09-40.79a11.22 11.22 0 00-8.3-18.75z"
                fill="currentColor"
            />
        </svg>
    );
}

export default SvgActFilter;
